var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button is-success add-to-cart-button",on:{"click":_vm.addToCart}},[_vm._v(" Add to Cart "),_c('i',{staticClass:"ml-2 pb-2 is-size-4 bi-cart2 navbar-show-icon-touch has-text-light"})])}
var staticRenderFns = []

export { render, staticRenderFns }